export const workspaceSignature =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">' +
  '<path d="M120-760v-80h720v80H120Zm640 80q33 0 56.5 23.5T840-600v400q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5' +
  'T120-200v-400q0-33 23.5-56.5T200-680h560Zm0 80H200v400h560v-400Zm-560 0v400-400Z"/>' +
  '</svg>';

export const doctorSignature =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">' +
  '<path d="M120-120v-80h720v80H120Zm80-160q-33 0-56.5-23.5T120-360v-400q0-33 23.5-56.5T200-840h560q33 0 56.5' +
  ' 23.5T840-760v400q0 33-23.5 56.5T760-280H200Zm0-80h560v-400H200v400Zm0 0v-400 400Z"/>' +
  '</svg>';

export const toolbar =
  '{bold,italic,underline,forecolor,backcolor}|{justifyleft,justifycenter,justifyright,justifyfull}' +
  '|{insertorderedlist,insertunorderedlist,indent,outdent,insertblockquote}#{preview,html2pdf}' +
  '/ {fontname:toggle,fontsize:toggle,paragraphs:toggle}|{removeformat,cut,copy,paste,delete}|{insertimage,inserttable,insertlink}|';
